$(document).on('turbo:load', async function () {
  let g_district = JSON.parse(window.localStorage.getItem('garbage_district'));
  let g_dates = await JSON.parse(window.localStorage.getItem('garbage_dates'));
  let categories = await JSON.parse(window.localStorage.getItem('garbage_types'));
  let garbage_push_type_ids = await JSON.parse(window.localStorage.getItem('garbage_push_type_ids'));
  let types_html = ``;
  if (g_district) {
    const targetElement = $("ul.g-districts-acc").find(`[data-gid='${g_district.id}']`).find("i");
    if (targetElement.length && !targetElement.siblings("a.selected_btn").length) {
      targetElement.before('<a class="selected_btn text-decoration-none" href="/abfallkalender"><p class="bg-primary c-pointer fs-small mt- pe-3 ps-3 rounded-pill text-white">Zum Kalender</p></a>');
      targetElement.removeClass("icon-checkbox-none")
    }
  }

  if (categories && categories.length && garbage_push_type_ids && g_district) {
    categories.forEach(category => {
      let isChecked = garbage_push_type_ids.includes(category.id) ? 'checked' : ''; // Check if category.id is in garbage_push_type_ids

      types_html += `<div class="col-md-12 d-flex justify-content-between">
        <p class="fs-small">${category.name}</p>
        <div class="form-check form-switch">
          <input class="form-check-input set-btn setting-switch" id="push-kind-3" data-push-kind="push-kind-3" data-id="${category.id}" type="checkbox" ${isChecked}>
        </div>
      </div>
      <hr class="border">`;
    });

    let show_html = `<div class="row bg-gray-100 p-3">
    <div class="col-12">
      <h3>Abfallinfo für ${g_district.name}</h3>
      <p>Du erhältst derzeit am Vortag der Abholung gegen 17 Uhr die Abfallinfo.</p>
    </div>
    ` + types_html + `</div>`;

    if ($("#show_g_types").is(':empty')) {
      $("#show_g_types").append(show_html);
    }
  }


  if (categories && g_district && g_dates && document.location.href.includes('einstellungen')) {
    $('#g-districts- li').find(".selected_btn").remove();
    $("ul#g-districts-").find(`[data-gid='${g_district.id}']`).find("i").before('<a class="selected_btn text-decoration-none" href="/abfallkalender"><p class="bg-primary c-pointer fs-small mt- pe-3 ps-3 rounded-pill text-white">Zum Kalender</p></a>');
    $("ul#g-districts-").find(`[data-gid='${g_district.id}']`).find("i").removeClass("icon-checkbox-none");
    setGarbageDistrict(g_district.id);
  }
  $('#g-districts- li').find('i').on('click', async function() {
    if ($('#g-districts- li').length < 2) return;
    const selectedDistrict = $(this).closest('li');
    const selectedDistrictId = selectedDistrict.data('gid');
    const selectedDistrictName = selectedDistrict.data('name');
    const selectedDistrictSortOrder = selectedDistrict.data('sortorder');
    const garbageDates = await setGarbageDistrict(selectedDistrictId);
    const garbageSubscription = await subscribe_ort_push_garbage(selectedDistrictId);
    const garbageTypes = await getGarbageTypes();
    const garbageTypeIds = garbageTypes.map(garbageType => garbageType.id);
    await window.localStorage.setItem('garbage_push_type_ids', JSON.stringify(garbageTypeIds));
    const current_ort_id = await JSON.parse(window.localStorage.getItem('current_city_id'));
    $("#show_g_types").empty();

    $('#g-districts- li').find('i').addClass('icon-checkbox-none');
    selectedDistrict.find('i').toggleClass('icon-checkbox-none');
    $('#g-districts- li').find(".selected_btn").remove();
    selectedDistrict.find("i").before('<a class="selected_btn text-decoration-none" href="/abfallkalender"><p class="bg-primary c-pointer fs-small mt- pe-3 ps-3 rounded-pill text-white">Zum Kalender</p></a>');
    $('.garbage-red-dot').addClass('d-none');

    const newGarbageDistrict = {
      id: selectedDistrictId,
      name: selectedDistrictName,
      sortorder: selectedDistrictSortOrder,
      selected_ort: current_ort_id
    };

    await window.localStorage.setItem('garbage_district', JSON.stringify(newGarbageDistrict));
    $('form[name=push_email_sub]').find('input[type=hidden][name=garbage_district_id]')
      .val(selectedDistrictId);
    window.localStorage.setItem('garbage_types', JSON.stringify(garbageTypes));
    window.localStorage.setItem('garbage_dates', JSON.stringify(garbageDates));

    if (selectedDistrict.parent().data('showToUser')) {
      $('#alert-title').text(`Du hast "${selectedDistrictSortOrder} (${selectedDistrictName})" als Deinen Abfallbezirk ausgewählt`);
      $('#alert-details').html(`<p>Bitte gehe zur <a class="link-dark fs-small text-primary fw-bold" href="/abfallinfo">Abfallinfo</a>, um Deine nächsten Abfalltermine einzusehen</p>
        <div class="row d-flex justify-content-end"><button class="btn btn-primary text-white" type="button" data-bs-dismiss="modal">OK</button></div>
      `);
      $('#alert-modal').modal('show');
    }
    let types_html = ``;
    let categories = await JSON.parse(window.localStorage.getItem('garbage_types'));
    categories.forEach(category => {
      types_html += `<div class="col-md-12 d-flex justify-content-between">
        <p class="fs-small">${category.name}</p>
        <div class="form-check form-switch">
          <input class="form-check-input set-btn setting-switch" id="push-kind-3" data-push-kind="push-kind-3" data-id="${category.id}" type="checkbox" checked>
        </div>
      </div>
      <hr class="border">`;
    });

    let show_html = `<div class="row bg-gray-100 p-3">
    <div class="col-12">
      <h3>Abfallinfo für ${selectedDistrictName}</h3>
      <p>Du erhältst derzeit am Vortag der Abholung gegen 17 Uhr die Abfallinfo</p>
    </div>
    ` + types_html + `</div>`;
    $("#show_g_types").append(show_html)
  });


  $('body').on("keyup", '#filter_gd_list', async function () {
    let s_text_ = $(this).val().toLowerCase();
    $("#g-districts- > li").each(function () {
      if ($(this).data("name").toLowerCase().search(s_text_) > -1) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  });

  // mk: do not request if garbage_districts_ == null
  let garbage_districts_ = await JSON.parse(window.localStorage.getItem('garbage_districts'));
  if (garbage_districts_ && garbage_districts_ != undefined && (garbage_districts_.data.length > 0) && !(g_district && garbage_districts_.data.find(i => i.id === g_district.id))) {
    $(".garbage-red-dot").removeClass("d-none");
  }
  // mk: do not request if garbage_districts_ == null
  if (garbage_districts_ && garbage_districts_ != undefined && garbage_districts_.data.length <= 0) {
    $(".show-garbage-button").addClass('d-none');
  }
  ($('#garbage-dates-container').length == 1) && ($("#garbage-dates-container").html().length < 3) && setGarbageItemsOnView();
  ($('#garbage-moreinfo-container').length == 1) && ($("#garbage-moreinfo-container").html().length < 3) && setGarbageMoreInfoOnView();
  if (!garbage_districts_ && !window.location.href.endsWith('/orte-list')) {
    let garbage_districts_ = await getGarbageDistrict();
    window.localStorage.setItem('garbage_districts', JSON.stringify(garbage_districts_));
  }
})
$(document).ready(async function() {
  const garbageDistricts = await JSON.parse(window.localStorage.getItem('garbage_districts'));
  const current_ort_id = await JSON.parse(window.localStorage.getItem('current_city_id'));

  if (garbageDistricts?.data?.length === 1) {
    const districtLi = $('#g-districts- li');
    districtLi.find('i').addClass('icon-checkbox-none').toggleClass('icon-checkbox-none');
    $('.garbage-red-dot').addClass('d-none');

    const newGarbageDistrict = {
      id: garbageDistricts.data[0].id,
      name: garbageDistricts.data[0].name,
      sortorder: garbageDistricts.data[0].sortorder,
      selected_ort: current_ort_id
    };
    await window.localStorage.setItem('garbage_district', JSON.stringify(newGarbageDistrict));
    const garbageDates = await setGarbageDistrict(newGarbageDistrict.id);
    const garbageSubscription = await subscribe_ort_push_garbage(newGarbageDistrict.id);
    const garbageTypes = await getGarbageTypes();

    $('form[name=push_email_sub]').find('input[type=hidden][name=garbage_district_id]')
      .val(newGarbageDistrict.id);
    await window.localStorage.setItem('garbage_types', JSON.stringify(garbageTypes));
    await window.localStorage.setItem('garbage_dates', JSON.stringify(garbageDates));

    if ($('#garbage-dates-container').length === 1) {
      $('#garbage-dates-container').empty();
      await setGarbageItemsOnView();
    }
  }
});

async function setGarbageItemsOnView() {
  let g_district = JSON.parse(window.localStorage.getItem('garbage_district'));
  let garbage_districts_ = await JSON.parse(window.localStorage.getItem('garbage_districts'));
  const garbageDistricts = Array.isArray(garbage_districts_?.data) ? garbage_districts_.data : [];
  const noDatesHtml = (districtName) => `<div class="box bg-white aside-garbage-card"><div class="box-middle aside-garbage-card__shell"><div class="aside-garbage-card__header"><div class="aside-garbage-card__heading"><span class="aside-garbage-card__kicker">Abfallkalender</span><h2 class="aside-garbage-card__title">${districtName}</h2></div><span class="icon-garbage aside-garbage-card__header-icon" aria-hidden="true"></span></div><div class="aside-garbage-card__body"><div class="aside-garbage-card__empty"><span class="icon-setting aside-garbage-card__empty-icon" aria-hidden="true"></span><strong>Abfallbezirk auswählen</strong><span>Bitte wähle Deinen Abfallbezirk in den Einstellungen aus.</span><a class="aside-garbage-card__settings-link" href="/einstellungen"><span>Einstellungen</span><span class="aside-garbage-card__alert"></span></a></div></div></div></div>`;
  let no_dates_html_ = noDatesHtml($(".main_city_name").text());
  if (g_district && garbageDistricts.length > 0) {
    if (g_district && garbageDistricts.find(i => i.id === g_district.id)) {
      var g_date_html_list = "";
      let categories = await JSON.parse(window.localStorage.getItem('garbage_types'));
      let g_dates = await JSON.parse(window.localStorage.getItem('garbage_dates'));
      const categoryMap = new Map(Array.isArray(categories) ? categories.map((category) => [category.id, category]) : []);
      const garbageDates = Array.isArray(g_dates?.data?.data) ? g_dates.data.data : [];
      const displayDates = garbageDates.filter((item) => categoryMap.has(item.garbage_type_id)).slice(0, 5);
      if (displayDates.length > 0) {
        displayDates.forEach(item => {
          const category = categoryMap.get(item.garbage_type_id);
          const categoryColor = `#${String("000000" + Math.abs(category.color1_rgb).toString(16)).slice(-6)}`;
          g_date_html_list += `<div class="aside-garbage-card__date" style="--garbage-type-color: ${categoryColor};"><span class="aside-garbage-card__date-kind">${category.name}</span><time class="aside-garbage-card__date-value" datetime="${item.pickup}">${new Date(item.pickup).toLocaleDateString('de-DE', { weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit' })}</time></div>`;
        })
        let dates_html_ = `<div class="box bg-white aside-garbage-card"><div class="box-middle aside-garbage-card__shell"><div class="aside-garbage-card__header"><div class="aside-garbage-card__heading"><span class="aside-garbage-card__kicker">Abfallkalender</span><h2 class="aside-garbage-card__title">${g_district.name}</h2></div><span class="icon-garbage aside-garbage-card__header-icon" aria-hidden="true"></span></div><div class="aside-garbage-card__body"><div class="aside-garbage-card__section-heading"><span>Deine nächsten Termine</span><span class="aside-garbage-card__count">${displayDates.length}</span></div><div class="aside-garbage-card__dates">${g_date_html_list}</div><a class="aside-garbage-card__link" href="/abfallinfo"><span>Zur Abfallinfo</span><span class="icon-arrow-right" aria-hidden="true"></span></a></div></div></div>`;
        $("#garbage-dates-container").append(dates_html_);
      }else {
        $("#garbage-dates-container").append(noDatesHtml(g_district.name));
      }
    } else {
      $("#garbage-dates-container").append(no_dates_html_);
    }
  } else {
    $("#garbage-dates-container").append(no_dates_html_);
  }

}
async function setGarbageMoreInfoOnView() {
  let g_district = JSON.parse(window.localStorage.getItem('garbage_district'));
  let current_ort_id = JSON.parse(window.localStorage.getItem('current_city_id'));
  let garbage_districts_ = await JSON.parse(window.localStorage.getItem('garbage_districts'));
  const garbageDistricts = Array.isArray(garbage_districts_?.data) ? garbage_districts_.data : [];
  (g_district && current_ort_id == g_district.selected_ort && garbageDistricts.length > 0) ? $("#g_info_title").text("Abfallbezirk " + g_district.name) : $("#g_info_details").addClass('d-none');
  let no_info_html = `<div class="row mt-3"><div class="col-12 text-center mt-3"><span class="fs-small fw-bold">Bitte wähle Deinen Abfallbezirk in den Einstellungen aus.</span></div><div class="col-12 mt-1"><a class="d-flex justify-content-center align-items-center link-dark text-decoration-none" href="/einstellungen"><div class="icon-setting"></div><span class="fs-6 ps-1 text-decoration-underline pe-1">Einstellungen</span><span class="bg-danger border border-light p-1 rounded-circle"></span></a></div></div>`;
  if (g_district && garbageDistricts.length > 0) {
    if (garbageDistricts.find(i => i.id === g_district.id)) {
      let heading_ = `<div class="row mt-4 garbage-info-section-heading"><div class="col-md-12"><h2 class="garbage-info-section-title">Allgemeine Informationen</h2><p class="garbage-info-section-copy">Tippe auf eine Abfallart, um weitere Informationen zu erhalten.</p></div></div>`;
      let list_of_types = ``;
      var g_date_html_list = "";
      let g_dates = await JSON.parse(window.localStorage.getItem('garbage_dates'));
      let categories = await JSON.parse(window.localStorage.getItem('garbage_types'));
      const categoryMap = new Map(Array.isArray(categories) ? categories.map((category) => [category.id, category]) : []);
      const garbageDates = Array.isArray(g_dates?.data?.data) ? g_dates.data.data : [];
      const displayDates = garbageDates.filter((item) => categoryMap.has(item.garbage_type_id)).slice(0, 5);
      if (displayDates.length > 0 && Array.isArray(categories) && g_district) {
        displayDates.forEach(item => {
          const category = categoryMap.get(item.garbage_type_id);
          const color1 = `#${String("000000" + Math.abs(category.color1_rgb).toString(16)).slice(-6)}`;
          const color2 = `#${String("000000" + Math.abs(category.color2_rgb).toString(16)).slice(-6)}`;
          g_date_html_list += `<div class="col-12 garbage-info-date-row" style="--garbage-color-1: ${color1}; --garbage-color-2: ${color2};"><span class="garbage-info-date-kind">${category.name}</span><time class="garbage-info-date-value" datetime="${item.pickup}">${new Date(item.pickup).toLocaleDateString('de-DE', { weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit' })}</time></div>`;
        })
        categories.forEach(item => {
          // create 6-digit hex-values from the int-value given
          let bg_color_1 = String("000000" + Math.abs(item.color1_rgb).toString(16)).slice(-6);
          let bg_color_2 = String("000000" + Math.abs(item.color2_rgb).toString(16)).slice(-6);
          list_of_types += `<li class="col-md-3 col-4 mt-2 c-pointer garbage-info-type-item" data-id="${item.id}"><div class="box h-100 garbage-info-type-card" style="--garbage-color-1: #${bg_color_1}; --garbage-color-2: #${bg_color_2};"><div class="box-middle garbage-info-type-body"><div class="garbage-info-type-icon"><img class="img-fluid" src="https://api.meinort.app/api/v1/garbage_types/${item.id}/icon" alt="" /></div><p class="garbage-info-type-name hyphens-a word-break-word">${item.name}</p></div></div></li>`;
        });
        let dates_html_ = `${heading_} <ul class="row d-flex flex-wrap list-unstyled garbage-info-type-grid" id="garbage_types"> ${list_of_types} </ul>`;
        let list_html_ = `<section class="garbage-info-upcoming"><div class="garbage-info-upcoming-heading"><div><span class="garbage-info-kicker">Abholtermine</span><h2 class="garbage-info-upcoming-title">Deine nächsten Termine</h2></div><a class="garbage-info-change-link" href="/einstellungen">Bezirk ändern</a></div><div class="garbage-info-upcoming-card"><div class="garbage-info-district-row"><span class="garbage-info-district-label">Abfallbezirk</span><strong>${g_district.name}</strong></div><div class="garbage-info-date-list">${g_date_html_list}</div><p class="garbage-info-disclaimer">Alle Angaben ohne Gewähr</p><div class="garbage-info-calendar-action"><a class="btn garbage-info-calendar-link" href="/abfallkalender" data-turbo="false"><span>Zum Abfallkalender</span><span class="icon-arrow-right" aria-hidden="true"></span></a></div></div></section>`;
        $("#garbage-moreinfo-container").append(dates_html_);

        $("#garbage-moreinfo-list-container").append(list_html_);
      }else {
        $("#garbage-moreinfo-list-container").html().length < 3 && $("#garbage-moreinfo-list-container").append(no_info_html);
      }
    } else {
      $("#garbage-moreinfo-list-container").html().length < 3 && $("#garbage-moreinfo-list-container").append(no_info_html);
    }
  } else {
    $("#garbage-moreinfo-list-container").html().length < 3 && $("#garbage-moreinfo-list-container").append(no_info_html);
  }

  $("#garbage_types li").on("click", async function () {
    let categories = await JSON.parse(window.localStorage.getItem('garbage_types'));
    let cat_ = categories.find(x => x.id === $(this).data("id"));
    let bg_color_1 = String("000000" + Math.abs(cat_.color1_rgb).toString(16)).slice(-6);
    let bg_color_2 = String("000000" + Math.abs(cat_.color2_rgb).toString(16)).slice(-6);
    // $("#alert-title").text(`Du hast  als Deinen Abfallbezirk ausgewählt`);
    if(cat_.description !== ""){
      $("#alert-details").html(`<div class="box br-10 h-100" style="background: linear-gradient( 130deg, #${bg_color_1} 50%, #${bg_color_2} 50%);">
     <div class="box-middle pb-0">
        <div class="row">
           <div class="col-12 d-flex justify-content-center mt-1"><img class="img-fluid" style="height: 50px;" src="https://api.meinort.app/api/v1/garbage_types/${$(this).data("id")}/icon"></div>
           <div class="col-12 d-flex justify-content-center mt-2">
              <p class="fs-6 text-dark fs-small hyphens-a word-break-word">${cat_.name}</p>
           </div>
        </div>
     </div>
  </div>
  <div class="row">
     <div class="col-12 mt-2">
        <h3 class="text-black-444">${cat_.name}</h3>
     </div>
     <div class="col-12 mt-2">
        <span class="text-black-444">${cat_.description}</span>
     </div>
  </div>
  `);
  $("#alert-modal").modal("show");
  }
  });
}

async function setGarbageDistrict(g_id) {
  const settings = {
    method: 'POST',
    headers: {
      Accept:         'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      gid:   g_id,
      token: window.localStorage.getItem('email-sub-token')
    })
  };
  // in order to save
  const resp = await fetch('/set_garbage_district_id.json', settings).
    then(res => res.clone().json());
  return resp;
}

async function subscribe_ort_push_garbage(gid) {
  navigator.serviceWorker && navigator.serviceWorker.ready.then(registration => {
    registration.pushManager.getSubscription()
      .then(subscription => {
        if (subscription) {
          window.Notification.requestPermission().then(permission => {
            if (permission === 'granted') {
              let formData = new FormData();
              formData.append('ort_id', JSON.parse(localStorage.getItem('main_city'))['id']);
              formData.append('garbage_district_id', gid);
              formData.append('subscription', JSON.stringify(subscription));
              return fetch(Routes.subscribe_pwa_garbage_path(), {
                method: 'post',
                headers: {
                  "X-CSRF-Token": document.querySelectorAll('meta[name="csrf-token"]')[0]["content"],
                  'X-Requested-With': 'XMLHttpRequest',
                },
                body: formData
              });
            }
          });
        }
      })
      .catch(function (err) {
        console.log('Error during getSubscription()', err);
      });
  });
}

async function getGarbageDistrict() {
  const response = await fetch('/get_garbage_district', {
    method: 'get',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
  }).then(res => res.clone().json())
  return response;
}
async function getGarbageTypes() {
  const response = await fetch('/garbage-types', {
    method: 'get',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
  }).then(res => res.clone().json())
  return response.data;
}
